import React from "react";

export default function ResumePanel({ founder, isAnimating }) {
  return (
    <div className={`pitch-panel ${isAnimating ? 'resume-slide-down' : ''}`}>
      <h1 className="resume-name">{founder.name}</h1>
      <p className="resume-contact">{founder.location} · Age {founder.age}</p>

      <div className="resume-section-title">Objective</div>
      <p className="resume-text">{founder.tagline}</p>

      <div className="resume-section-title">Education</div>
      <div className="resume-entry">
        <div className="resume-entry-title">{founder.education}</div>
      </div>

      <div className="resume-section-title">Startup</div>
      <div className="resume-entry">
        <div className="resume-entry-header">
          <span className="resume-entry-title">{founder.companyName}</span>
          <span className="resume-entry-right">Founder & CEO</span>
        </div>
        <p className="resume-entry-subtitle">{founder.companyDesc}</p>
        <ul className="resume-bullets">
          <li>Seeking: <span className="resume-ask">{founder.ask}</span></li>
          {founder.metrics.map((m, i) => (
            <li key={i}>{m.label}: {m.value}</li>
          ))}
        </ul>
      </div>

      <div className="resume-section-title">Experience</div>
      <ul className="resume-bullets">
        {founder.highlights.map((h, i) => (
          <li key={i}>{h}</li>
        ))}
      </ul>

      <div className="resume-section-title">Skills & Interests</div>
      <p className="resume-text">
        {founder.badges.join(' · ')} · {founder.hobbies.join(' · ')}
      </p>
    </div>
  );
}
